import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { axiosInstance } from "../api/axiosInstance";

export const sellerApiSlice = createApi({
  reducerPath: "sellerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: axiosInstance.defaults.baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("auction_portal");
      if (token) {
        headers.set("x-auth-token", token);
      }
      return headers;
    },
  }),
  tagTypes: ["Seller"],
  endpoints: (builder) => ({
    // Get all sellers with pagination
    getSellers: builder.query({
      query: ({ endpoint, lastId, params }) => {
        const url = lastId ? `${endpoint}${lastId}` : endpoint;
        return {
          url,
          method: "GET",
          params: params || undefined,
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...(result.sellers || result.data?.sellers || []).map(({ _id }) => ({
                type: "Seller",
                id: _id,
              })),
              { type: "Seller", id: "LIST" },
            ]
          : [{ type: "Seller", id: "LIST" }],
    }),

    // Get seller by ID
    getSellerById: builder.query({
      query: (id) => `seller/detail/${id}`,
      providesTags: (result, error, id) => [{ type: "Seller", id }],
    }),

    // Create seller
    createSeller: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Seller"],
    }),

    // Update seller
    updateSeller: builder.mutation({
      query: ({ endpoint, id, data }) => ({
        url: `${endpoint}${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Seller", id },
        "Seller",
      ],
    }),

    // Delete seller
    deleteSeller: builder.mutation({
      query: ({ endpoint, id }) => ({
        url: `${endpoint}${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Seller", id },
        "Seller",
      ],
    }),

    // Get seller metrics
    getSellerMetrics: builder.query({
      query: () => "seller/dashboard",
      providesTags: ["Seller"],
    }),
  }),
});

export const {
  useGetSellersQuery,
  useGetSellerByIdQuery,
  useCreateSellerMutation,
  useUpdateSellerMutation,
  useDeleteSellerMutation,
  useGetSellerMetricsQuery,
} = sellerApiSlice;